import { createUseProvidedContext as t } from "./index174.mjs";
import { ConfigContext as o } from "./context2.mjs";
const n = t(
  o,
  "ConfigContext"
), m = () => {
  const { theme: e } = n();
  return e;
};
export {
  n as useStennConfig,
  m as useStennTheme
};
//# sourceMappingURL=useStennTheme.mjs.map
